import request from '@/router/axios'
const urlPrefix = '/sys';
let Base64 = require('js-base64').Base64

export function getMyInfo() {
  return request({
    url: '/user/user/myinfo',
    method: 'get',
  });
}

export function changePassword(obj) {
  return request({
    url: urlPrefix+'/user/updatePassword',
    method: 'put',
    data: obj,
  });
}

export function changePhone(obj) {
  return request({
    url: '/user/user/mobile',
    method: 'put',
    data: obj,
  });
}
export function getSmsCode(phone) {
  return request({
    url: `/user/smsCode/${phone}`,
    method: 'get',
  });
}

export function changeEmail(email) {
  return request({
    url: '/user/user/email',
    method: 'put',
    data: { email },
  });
}

export function edituser(obj) {
  return request({
    url: '/user/user/editone',
    method: 'put',
    data: obj,
  });
}

export function downLoadFile(id) {
  id = Base64.encode(encrypt(id,'payrollEncry24pt'))
  return request({
    url: `file/${id}`,
    method: 'get',
    responseType: 'arraybuffer',

  });
}

/**
 * 获取附件信息
 * @param id
 */
export function getFileInfo(id) {
  id = Base64.encode(encrypt(id,'payrollEncry24pt'))
  return request({
    url: `/file/info/`+id,
    method: 'get',

  });
}
//新增用户通行证
export function addUserPass(id, pass) {
  return request({
    url: `/user/user/${id}/pass`,
    method: 'post',
    data: { ids: pass },
  });
}
//删除用户通行证
export function deleteUserPass(id, pass) {
  return request({
    url: `/user/user/${id}/pass`,
    method: 'delete',
    data: { ids: pass },
  });
}

//邀请
export function invitationMember(obj) {
  return request({
    url: '/user/invitation/member',
    method: 'post',
    data: obj,

  });
}

//获取用户数量
export function getUserNum(obj){
  return request({
    url: `/user/user-login-credentials/count`,
    method: 'get',
    params: obj
  });
}
/**
 *
 * 发送手机验证码
 * type
 * 1--登录
 * 2--注册
 * 3--找回密码
 * 4--修改手机号
 * @param data
 */
export function sendSmsCode(data) {
  return request({
    url: "/user/sms-code/"+data.mobile+"/type/"+data.type,
    method: 'get',
    headers: {
      Authorization: 'Basic Y2lpYy1jbG91ZC1wbGF0Zm9ybTpjaWljLWNsb3VkLXBsYXRmb3Jt',
    },
  });
}

/**
 * 菜单埋点
 * @param data
 */
export function aveLog(data) {
  return request({
    url: urlPrefix + '/funlog/saveLog',
    method: 'post',
    data
  });
}
